import React, { useEffect, useMemo, useState } from 'react';
import { Layout } from 'tea-component';
import {
  FilterFixed,
  useFilterDataHook,
} from '@/pages/opinion/components/FilterCommon';
import { connect, useDispatch } from 'umi';
import '@/pages/opinion/assets/scss/pages/stats/version.scss';
import CardLoading from '@/pages/opinion/components/CardLoading';
import useLanguage from '@/pages/opinion/hooks/useLanguage';
import ChartsBox from '../components/ChartsBox';
import { useInitBuriedPointInfo } from '@/pages/opinion/operationLog/buriedPoint';
import StatsVersionPoint from '@op/operationLog/pages/statsVersion';
import ContentBody from '@/pages/opinion/components/ContentBody';
import { PAGE_NAME } from '@op/constants/page';
import { DBO_TM } from '@op/utils/format';
import DetailPageTable, { ChannelType } from '@op/components/DetailPageTable';
const { Content } = Layout;

function Version({ gameInfo, version, versionLoading, wholeGameInfo }: any) {
  const [channelType, setChannelType] = useState<ChannelType>('social');
  useInitBuriedPointInfo({ buriedPoint: StatsVersionPoint });
  const {
    loading,
    filter,
    changeFilter,
    scrollBody,
    filterOptions,
    changeTopicList,
    topicList,
  } = useFilterDataHook({
    gameInfo,
    pageName: 'Stats_Version',
  });
  const { formatMessage } = useLanguage();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!gameInfo || !filter) return;
    dispatch({
      type: 'opinionPerformance/getOverviewVersionTimeline',
      payload: {
        ...filter,
        ...gameInfo,
        top_n: 10,
      },
    });
  }, [gameInfo, filter]);

  const filterParams = useMemo(() => {
    const { period, version_time, ...otherFilter } = filter || {};

    return otherFilter;
  }, [filter]);

  return (
    <Content className="dbo-version dbo-stats" ref={scrollBody}>
      <ContentBody
        pageName={PAGE_NAME.VERSION}
        contentHeard={
          <Content.Header title={formatMessage({ id: PAGE_NAME.VERSION })} />
        }
      >
        <FilterFixed
          filter={filterOptions}
          operateShowOptions={['more', 'history', 'tips']}
          scrollBody={scrollBody}
          confirm={(value: any) => {
            const todayTime = DBO_TM.today('daily');
            changeFilter({
              ...value,
              ...todayTime,
              ...gameInfo,
              statistics_field: 'version',
            });
          }}
          backCondOriginData={(value) => {
            changeTopicList({ topic_trans: value.topic_trans, key_topic: {} });
          }}
          beforeCacheDealwithData={() => false}
        ></FilterFixed>
        <CardLoading loading={loading}>
          <ChartsBox
            data={version}
            loading={versionLoading}
            gameInfoDetail={wholeGameInfo}
            filter={filter}
            dataType="version"
            isVersion
          ></ChartsBox>
          <DetailPageTable
            hasNews={true}
            gameInfo={gameInfo}
            channelType={channelType}
            setChannelType={setChannelType}
            defaultPageInfo={{ page: 1, page_size: 5 }}
            filter={filterParams}
            hasPageable={false}
            wholeGameInfo={wholeGameInfo}
          ></DetailPageTable>
        </CardLoading>
      </ContentBody>
    </Content>
  );
}

export default connect((state: any) => {
  const { loading, opinionCommon, opinionPerformance } = state;

  return {
    gameInfo: opinionCommon.gameInfo,
    wholeGameInfo: opinionCommon.wholeGameInfo,

    version: opinionPerformance.version,
    versionLoading:
      loading.effects['opinionPerformance/getOverviewVersionTimeline'],
  };
})(Version);
